const FONTS_FAMILY = {
  regular: {
    body: 'NunitoSans-Regular',
    title: 'FiraSans-Regular',
  },
  medium: {
    body: 'NunitoSans-SemiBold',
    title: 'FiraSans-Medium',
  },
  bold: {
    body: 'NunitoSans-Bold',
    title: 'FiraSans-Bold',
  },
};

export default FONTS_FAMILY